export const HAS_BEEN_CLOSED_MARK = 'afMLSNPublicationBannerClosed';
